import React from 'react';

type Props = {
    children: React.ReactNode
}

function DescriptionList(props: Props) {
    return (
        <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
            {props.children}
        </dl>
    );
}

export default DescriptionList;